import { i18n } from 'i18n'
import { parseFinite } from 'util/number'
import { load, save } from 'util/storage'

export const TERM = 'term.'

export enum TermType {
  FOREVER = 'forever',
  MONTH = 'month',
  WEEK = 'week',
}

const termTypes = [TermType.FOREVER, TermType.MONTH, TermType.WEEK]

export type Term = {
  type: TermType
  created: number
}

export function isTermType(text: string | undefined): text is TermType {
  return termTypes.includes(text as any)
}

export function loadTerm(user_id: string): Term | undefined {
  if (!user_id) return undefined
  const text = load(TERM + user_id)
  if (!text) return undefined
  const [type, _created] = text.split('|')
  if (!isTermType(type)) return undefined
  const created = parseFinite(_created)
  if (!created) return undefined
  return { type, created }
}

export function fixTerm(term: Term | undefined): Term | undefined {
  const forever = !term || term.type === TermType.FOREVER
  return forever ? undefined : term
}

export function saveTerm(user_id: string | undefined, term: Term | undefined) {
  if (!user_id) return
  term = fixTerm(term)
  if (term) {
    const { type, created } = term
    save(TERM + user_id, type + '|' + created)
  } else {
    save(TERM + user_id, undefined)
  }
}

export function getTermUntil(term: Term): number | undefined {
  const { type, created } = term
  const date = new Date(created)
  if (type === TermType.FOREVER) date.setFullYear(date.getFullYear() + 99)
  if (type === TermType.MONTH) {
    date.setMonth(date.getMonth() + 1)
    return date.getTime()
  }
  if (type === TermType.WEEK) {
    date.setDate(date.getDate() + 7)
    return date.getTime()
  }
  return undefined
}

export function getTermLabel(value: TermType) {
  switch (value) {
    case TermType.FOREVER:
      return i18n('term.Forever')
    case TermType.MONTH:
      return i18n('term.Month')
    case TermType.WEEK:
      return i18n('term.Week')
    default:
      return ('' + value || 'none').toUpperCase()
  }
}
